import { toast } from "sonner";
import { BellRing } from "lucide-react";
import type { Agent } from "@/types";
import { SectionCard } from "@/components/SectionCard";
import { useUpdateConnectionWake } from "@/api/mutations/connectionWake";

// #245 (Teil B): Connection-Wake opt-in. Schaltet den aktiven Agent-Wake ein/aus,
// der bei einer akzeptierten AUSGEHENDEN Verbindungsanfrage einen System-Inbox-Turn
// auslöst (der Agent setzt die zuvor blockierte Aufgabe fort). Default aus (Kosten).
// Owner-Notifications über den ganzen Lifecycle (Teil A) laufen unabhängig davon.
export function ConnectionWakeSection({ agent }: { agent: Agent }) {
  const update = useUpdateConnectionWake(agent.id);
  // Version-Skew-Hardening: älterer Master ohne das Feld → false.
  const checked = agent.connectionWakeOnAccepted ?? false;

  function toggle(value: boolean) {
    update.mutate(value, {
      onSuccess: () => toast.success(`Connection-Wake: ${value ? "an" : "aus"}`),
      onError: (err) => toast.error(`Connection-Wake fehlgeschlagen: ${(err as Error).message}`),
    });
  }

  return (
    <SectionCard
      icon={<BellRing className="h-[18px] w-[18px]" />}
      title="Connection-Wake"
      description="Agent bei akzeptierter Verbindungsanfrage aktiv aufwecken"
    >
      <label className="flex items-start gap-3">
        <input
          type="checkbox"
          className="mt-0.5 h-4 w-4 shrink-0 accent-accent"
          checked={checked}
          disabled={update.isPending}
          onChange={(e) => toggle(e.target.checked)}
          data-testid="connection-wake-toggle"
        />
        <span className="min-w-0">
          <span className="block text-[13px] font-semibold text-text">
            Bei akzeptierter ausgehender Anfrage aufwecken
          </span>
          <span className="block text-[11.5px] text-text3">
            Sobald eine vom Agent gestellte Verbindungsanfrage angenommen wird, startet der Master
            einen Turn, damit der Agent die zuvor blockierte Aufgabe fortsetzen kann. Kostet pro
            Annahme einen LLM-Turn — daher standardmäßig aus.
          </span>
        </span>
      </label>
    </SectionCard>
  );
}
